/**
 * Memory Types Configuration
 *
 * Defines the different types of memories and their capabilities.
 * Per-integration capabilities are sourced from integrations/capabilities/memoryModalities.ts.
 */

export type { IntegrationMemoryCapabilities } from '@/integrations/capabilities/memoryModalities';
export { getIntegrationMemoryCapabilities } from '@/integrations/capabilities/memoryModalities';

export interface MemoryType {
  id: string;
  name: string;
  icon: string;
  badge: string;
  description: string;
  color: 'orange' | 'purple' | 'gray';
  status: 'available' | 'planned';
}

export const memoryTypes: Record<string, MemoryType> = {
  text: {
    id: 'text',
    name: 'Text',
    icon: '📝',
    badge: 'Text',
    description: 'Text-based memories',
    color: 'purple',
    status: 'available',
  },
  audio: {
    id: 'audio',
    name: 'Audio',
    icon: '🎵',
    badge: 'Audio',
    description: 'Audio memories',
    color: 'orange',
    status: 'available',
  },
  image: {
    id: 'image',
    name: 'Image',
    icon: '🖼️',
    badge: 'Image',
    description: 'Image memories',
    color: 'purple',
    status: 'available',
  },
  video: {
    id: 'video',
    name: 'Video',
    icon: '🎬',
    badge: 'Video',
    description: 'Video memories',
    color: 'purple',
    status: 'planned',
  },
};
